import { render, staticRenderFns } from "./surface_beethoven_preview.vue?vue&type=template&id=5a3f19c6&scoped=true&"
import script from "./surface_beethoven_preview.vue?vue&type=script&lang=js&"
export * from "./surface_beethoven_preview.vue?vue&type=script&lang=js&"
import style0 from "./surface_beethoven_preview.vue?vue&type=style&index=0&id=5a3f19c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3f19c6",
  null
  
)

export default component.exports